export * from './tooltip';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/tooltip/index.js
// module id = 419
// module chunks = 3